module.exports = __webpack_public_path__ + "4d50aa08677a22ece3c54e795790aa6a.png";